module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_13.png?7b7f0f0ba06b996abff30284bca51299";